import { gql } from 'graphql.macro';

export const UpdateIssue = gql`
    mutation updateIssue($request: UpdateIssueRequestModelInput) {
        updateIssue(request: $request)
    }
`;

export const CompleteIssue = gql`
    mutation CompleteIssue($request: CompleteIssueRequestModelInput) {
      completeIssue(request: $request)
    }
`;

export const ReopenIssue = gql`
mutation ReOpenIssue($nearMissId: Int!) {
  reopenIssue(nearMissId: $nearMissId)
}
`;

export const UpdateFile = gql`
  mutation updateFile($request: FileUpdateRequestInput) {
    updateFile(request: $request)
  }
`;

export const DeleteFile = gql`
  mutation deleteFile($referenceId: Uuid!, $fileId: Int!) {
    deleteFile(referenceId: $referenceId, fileId: $fileId)
  }
`;